import React, { useEffect, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import moment from 'moment';
import * as XLSX from 'xlsx'
import ExportButtons from '../ExportButtons';
import { formatCurrency } from '../../../../../../helpers/pcontas';

const ExpenseReportV1 = (props) => {
    const [items, setItems] = useState([]);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');

    useEffect(() => {
        const fetchData = async () => {
            const response = await Fetch.post(config.endpoints.backend + 'portal/getreport', props.filters);
            setItems(response);
        }

        fetchData();
    }, [props.filters])

    function dataForSheet(){
        let sheets = {};

        const expenseReportV1Table = document.getElementById('expenseReportv1');
        const expenseReportV1Data = XLSX.utils.sheet_to_json((XLSX.utils.table_to_sheet(expenseReportV1Table, {raw: true})), {raw: true, header: 1});

        sheets.expenseReportV1Data = expenseReportV1Data;
        
        return sheets;
    }

    function dataForCsv() {
        const tableExpenseReportV1 = document.getElementById('expenseReportv1');
    
        const dataTableExpenseReportV1 = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(tableExpenseReportV1, {raw: true}), { header: 1, raw: true});

        return dataTableExpenseReportV1
    }

    function dataForJson(){
        let expenseReportv1 = [];

        if(!!items.reports.report){
            items.reports.report.forEach(item => {
                let currentObject = {};
                for (const key of items.reports.headers) {
                    currentObject[key] = item[key];
                }

                expenseReportv1.push(currentObject)
            })
        }

        return {
            expenseReportv1
        };
    }

    return (
        <div>
        {items.reports && (
                <div className='containerDird'>   
                    <div className='row info-filters'>
                        <div className='col-12'>
                            <p>Projeto: <b>{items.reports.pdcProject.project_name}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Origem dos Recursos: <b>{items.reports.originResourceName}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Período Selecionado: <b>{startDate} até {endDate}</b></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <ExportButtons 
                            jsonData={dataForJson} 
                            csvData={dataForCsv} 
                            sheetData={dataForSheet} 
                            pdfAttributes={
                                {
                                    ids: ['expenseReportv1'], 
                                    optionsPdf: {orientation: 'landscape'},
                                    styles:{
                                        expenseReportv1:{
                                            columnStyles: {
                                                6: { cellWidth: 30 }
                                            }
                                        }
                                    }
                                }
                           }
                           txtAttributes={{
                                expenseReportv1: {
                                    colSizes: [80]
                                },
                            }}
                    />
                    </div>
                    <div class="row">
                        <table className="table tables-report" id='expenseReportv1' margin="2" cellspacing="0" cellpadding="5">
                            <thead className='text-center '>
                                <tr>
                                    {items.reports.headers.map(header => (<th style={{maxWidth: '200px'}} className=''>{header}</th>))}
                                </tr>
                            </thead>
                            <tbody className='tbody-dird'>
                                {items.reports.report.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                    {Object.keys(row).map((item) => {
                                       let currentValue = items.reports.report[rowIndex][item];
                                       let className = 'text-right';
                                        if(item === 'Valor'){
                                            currentValue = formatCurrency(currentValue);
                                        }else if(item === 'Fornecedor/Prestador' || item === 'Natureza da Despesa'){
                                            className = 'text-left';
                                        }else{
                                            className = 'text-center';
                                        }
                                       return <td className={className}>{currentValue}</td>
                                    })}
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={6}>Total</td>
                                    <td className='tdValue' colSpan={1}>{formatCurrency(items.reports.totalSum.toFixed(2))}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};
    
export default ExpenseReportV1;
    